import {
  ExperienceApiResponse,
  SearchResultsV2ResponseData,
  SearchV2Result,
  VehicleV2,
  VehicleV2ApiResponseData,
  VehicleWithExperienceApiResponse,
} from './types';

export function transformSrpVehicle(
  apiData: VehicleV2ApiResponseData,
  experienceData?: ExperienceApiResponse
): VehicleV2 {
  const { city, state } = apiData;

  return {
    vin: apiData.vin,
    hasImages: apiData.has_photos,
    images: apiData.photo_urls,
    make: apiData.make_name,
    model: apiData.model_name,
    year: apiData.year,
    city,
    state,
    mileage: apiData.mileage,
    showNewMileage: apiData.show_new_mileage,
    price: apiData.price,
    location: experienceData?.display_location || `${city}, ${state}`,
    dealerName: experienceData?.dealer_name || apiData.dealer_name,
    isHot: apiData.is_hot,
    hasRecentPriceDrop: apiData.recent_price_drop,
    trackingParams: apiData.tracking_params,
    isRegional: apiData.regional,
    partnerType: apiData.partner_type,
    cplValue: apiData.cpl_value,
    zip: apiData.zip || '',
    buyerIntelligence: {
      relativePriceDiff: apiData.relative_price_difference,
      totalPriceChange: apiData.total_price_change,
      timeOnMarket: apiData.time_on_market,
    },
  };
}

export function transformSrpResult(
  searchResults: SearchResultsV2ResponseData,
  vehiclesWithExperience: VehicleWithExperienceApiResponse[]
): SearchV2Result {
  const vehiclesWithExperienceLookup: { [vin: string]: VehicleWithExperienceApiResponse } = {};
  vehiclesWithExperience.forEach((v) => {
    vehiclesWithExperienceLookup[v.vehicle.vin] = v;
  });

  const transformedRecords = searchResults.records.map((vehicle) => {
    const vehicleWithExperience: VehicleWithExperienceApiResponse | undefined =
      vehiclesWithExperienceLookup[vehicle.vin];

    return transformSrpVehicle(vehicle, vehicleWithExperience?.experience);
  });

  return {
    vehicles: transformedRecords,
  };
}
